/**
 * Polyfill object-fit/object-position on <img>: IE9, IE10, IE11, Edge, Safari, ...
 */
// @ts-ignore: No types
import objectFitImages from 'object-fit-images'
objectFitImages()
